import React, { useState, useRef, useEffect, Fragment } from 'react';
import { Modal, ModalBody } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHotel, faClock, faMapMarkerAlt, faClipboard, faFlag,
  faDoorClosed, faPlus, faMinus, faSave, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { ResponseSuccessModal, ResponseFailModal } from '../../modal/Response';
import timezoneItems from '../../../assets/timezone.json';
import * as api from '../../../api';

const HotelCreate = ({
  isOpen,
  toggle,
  reload,
}) => {
  const commonroomInputRef = useRef(null);
  const [ isOpenHotelCreateSuccessModal, setIsOpenHotelCreateSuccessModal ] = useState(false);
  const [ isOpenHotelCreateFailModal, setIsOpenHotelCreateFailModal ] = useState(false);
  const [ activeTab, setActiveTab ] = useState(1);
  const [ hotelCreateItem, setHotelCreateItem ] = useState({
    name: '',
    timezone: 'Asia/Seoul',
    address: '',
    desc: '',
    pincodeDayTypeOffset: '1200',
    commonrooms: [],
  });
  const formData = new FormData();

  const addCommonroom = () => {
    if (!commonroomInputRef.current.value) return;
    const commonrooms = [...hotelCreateItem.commonrooms];
    commonrooms.push({name: commonroomInputRef.current.value});
    setHotelCreateItem({
      ...hotelCreateItem,
      commonrooms: commonrooms,
    });
    commonroomInputRef.current.value = null;
  };

  const removeCommonroom = (index) => {
    const commonrooms = [...hotelCreateItem.commonrooms];
    commonrooms.splice(index, 1);
    setHotelCreateItem({
      ...hotelCreateItem,
      commonrooms: commonrooms,
    });
  };

  const setFile = (file) => {
    formData.append('file', file);
  };

  const createHotel = async () => {
    try {
      const res = await api.createHotel(hotelCreateItem);
      toggle();
      setIsOpenHotelCreateSuccessModal(true);
      setTimeout(() => {
        setIsOpenHotelCreateSuccessModal(false);
        reload(res.data.id);
      }, 1500);
    } catch (error) {
      setIsOpenHotelCreateFailModal(true);
    }
  };

  const createFacilityByExcelUpload = async (file) => {
    try {
      const res = await api.createFacilityByExcelUpload({file});
      toggle();
      setIsOpenHotelCreateSuccessModal(true);
      setTimeout(() => {
        setIsOpenHotelCreateSuccessModal(false);
        reload(res.data.id);
      }, 1500);
    } catch (error) {
      setIsOpenHotelCreateFailModal(true);
    }
  };

  useEffect(() => {
    setHotelCreateItem({
      name: '',
      timezone: 'Asia/Seoul',
      address: '',
      desc: '',
      pincodeDayTypeOffset: '1200',
      commonrooms: [],
    });
  }, [isOpen]);

  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        backdrop='static'
        size='md'
      >
        <ModalBody className='m-3' style={{margin:0, padding:0, backgroundColor:'#282C34'}}>
          <div className='form-card'>
            <div className='form-card-title'>
              <h4>New Property</h4>
            </div>
            <div className='form-tab modal-detail'>
              <p className={`tab-item ${activeTab !== 1 ? 'inactive':''}`} onClick={() => setActiveTab(1)}>Normal</p>
              <p className={`tab-item ${activeTab !== 2 ? 'inactive':''}`} onClick={() => setActiveTab(2)}>Bulk</p>
            </div>
            <div hidden={activeTab !== 1}>
              <div className='inline-flex tab'>
                <div className='w-100'>
                  <div className='card-text'>
                    <p>
                      <FontAwesomeIcon icon={faHotel}/>
                      <b> Name </b><span className='required'>*</span>
                    </p>
                    <input
                      className='card-text-input'
                      placeholder='Please enter name.'
                      onChange={e => setHotelCreateItem({...hotelCreateItem, name:e.target.value})}
                    />
                  </div>
                  <div className='card-text'>
                    <p>
                      <FontAwesomeIcon icon={faClock}/>
                      <b> Timezone </b><span className='required'>*</span>
                    </p>
                    <select
                      className='card-text-select'
                      value={hotelCreateItem.timezone}
                      onChange={e => setHotelCreateItem({...hotelCreateItem, timezone:e.target.value})}
                    >
                      {timezoneItems.map((timezoneItem, index) => (
                        <option key={index} value={timezoneItem.code}>{timezoneItem.code}</option>
                      ))}
                    </select>
                  </div>
                  <div className='card-text'>
                    <p>
                      <FontAwesomeIcon icon={faMapMarkerAlt}/>
                      <b> Address </b>
                    </p>
                    <input
                      className='card-text-input'
                      placeholder='Please enter address.'
                      onChange={e => setHotelCreateItem({...hotelCreateItem, address:e.target.value})}
                    />
                  </div>
                  <div className='card-text'>
                    <p>
                      <FontAwesomeIcon icon={faClipboard}/>
                      <b> Description </b>
                    </p>
                    <input
                      className='card-text-input'
                      placeholder='Please enter description.'
                      onChange={e => setHotelCreateItem({...hotelCreateItem, desc:e.target.value})}
                    />
                  </div>
                  <div className='card-text'>
                    <p>
                      <FontAwesomeIcon icon={faFlag}/>
                      <b> PIN code day type offset </b><span className='required'>*</span>
                    </p>
                    <select
                      className='card-text-select'
                      value={hotelCreateItem.pincodeDayTypeOffset}
                      onChange={e => setHotelCreateItem({...hotelCreateItem, pincodeDayTypeOffset:e.target.value})}
                    >
                      {new Array(24).fill().map((value, index) => (
                        <option
                          key={index}
                          label={index < 10 ? `0${index}:00` : `${index}:00`}
                          value={index < 10 ? `0${index}00` : `${index}00`}
                        />
                      ))}
                    </select>
                  </div>
                  <div className='card-box'>
                    <p>
                      <FontAwesomeIcon icon={faDoorClosed}/>
                      <b> Common door </b>
                    </p>
                    <div className='card-box-input-container'>
                      <input ref={commonroomInputRef} className='card-box-input' placeholder='Please enter commonroom name.'></input>
                      <div className='card-box-input-button' onClick={addCommonroom}>
                        <FontAwesomeIcon icon={faPlus} className='icon-item-add'/>
                      </div>
                    </div>
                    <div className='card-box-text-container'>
                      {hotelCreateItem.commonrooms.map((commonroom, index) => (
                        <div className='card-box-text' key={index}>
                          <p>{commonroom.name}</p>
                          <div className='card-box-input-button' onClick={() => removeCommonroom(index)}>
                            <FontAwesomeIcon icon={faMinus} className='icon-item-cancel'/>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className='card-foot' style={{paddingLeft:'1.8rem'}}>
                <div className='form-item-cancel'>
                  <button className='btn-item-cancel' onClick={() => toggle()}>
                    <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/><span>Cancel</span>
                  </button>
                </div>
                <div className='form-item-add center'>
                  <button className='btn-item-add' onClick={createHotel}>
                    <FontAwesomeIcon icon={faSave} style={{paddingRight:'2px'}}/><span>Save</span>
                  </button>
                </div>
              </div>
            </div>
            <div hidden={activeTab !== 2}>
              <div className='inline-flex tab'>
                <div className='w-100 excel-desc'>
                  <p>Excel 파일 업로드를 통해서 단지뿐만 아니라 여러 빌딩, 층, 객실까지 한번에 생성 가능</p>
                  <p>
                    * Excel 파일 업로드 규칙<br></br>
                    1. 1개의 파일만 가능하며, 1개의 sheet만 가능.<br></br>
                    2. sheet의 이름을 'sheet1'로 작성하고<br></br>
                    3. 1행 A열 부터<br></br>
                    4. 단지 이름(필수), 빌딩 이름(필수), 층 이름, 방 이름(필수), RMS ID 순으로 작성.<br></br>
                    단, 셀 서식이 '텍스트'여야 함.<br></br>
                  </p>
                  <p>
                    예:<br></br>
                    ABC Hotel, A동, 1F, 101호, 000001 (O)<br></br>
                    ABC Hotel, A동, '', 102호, '' (O)<br></br>
                    ABC Hotel, '', 1F, 103호, 000002 (X)<br></br>
                  </p>
                  <input className='modal-form-input' type='file' onChange={e => setFile(e.target.files[0])}></input>
                </div>
              </div>
              <div className='card-foot' style={{paddingLeft:'1.8rem'}}>
                <div className='form-item-cancel'>
                  <button className='btn-item-cancel' onClick={() => toggle()}>
                    <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/><span>Cancel</span>
                  </button>
                </div>
                <div className='form-item-add center'>
                  <button className='btn-item-add' onClick={() => createFacilityByExcelUpload(formData)}>
                    <FontAwesomeIcon icon={faSave} style={{paddingRight:'2px'}}/><span>Save</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <ResponseSuccessModal
        isOpen={isOpenHotelCreateSuccessModal}
        toggle={() => setIsOpenHotelCreateSuccessModal(!isOpenHotelCreateSuccessModal)}
        message='Property create success.'
      />
      <ResponseFailModal
        isOpen={isOpenHotelCreateFailModal}
        toggle={() => setIsOpenHotelCreateFailModal(!isOpenHotelCreateFailModal)}
        message='Property create success.'
      />
    </Fragment>
  );
};

export default HotelCreate;